import { useLanguage } from "@/context/LanguageContext";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/lib/api";

export const CTASection = ({ heading, sub }) => {
  const { t } = useLanguage();
  return (
    <section className="relative overflow-hidden border-t border-line bg-sand" data-testid="cta-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 md:px-10 md:py-32 lg:grid-cols-12 lg:gap-10">
        <Reveal className="lg:col-span-6">
          <p className="text-xs uppercase tracking-[0.25em] text-bronze md:text-sm">{t.form.title}</p>
          <h2 className="mt-4 max-w-xl font-serif text-4xl leading-none tracking-tight text-ink md:text-5xl lg:text-6xl">
            {heading || t.ctaSection.heading}
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-stone md:text-lg">
            {sub || t.ctaSection.sub}
          </p>
          <div className="mt-10">
            <a
              data-testid="cta-whatsapp-button"
              href={waLink(t.common.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 border border-ink px-8 py-4 text-sm font-medium uppercase tracking-widest text-ink transition-colors duration-300 hover:bg-ink hover:text-ivory"
            >
              {t.ctaSection.whatsapp}
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="border border-line bg-white p-7 shadow-xl shadow-ink/5 md:p-9">
            <LeadForm source="cta-section" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
